import { OfficeThemeMode } from '@office-start/theming-service';
export var isVisualBackgroundEnabled = function (isConsumer, isHighContrast, flight, themeId, themeMode, visualGates) {
    // Determine background enabled based on route & respective flight
    if (!flight ||
        !(flight && visualGates.visualEnabled && visualGates[flight])) {
        return false;
    }
    // Office is the themeId for default
    // themeMode is not set updated when windows HighContrast is set, hence checking for that using media queries
    if (themeMode !== OfficeThemeMode.highContrast &&
        !isHighContrast &&
        (isConsumer || themeId === 'Office')) {
        return true;
    }
    return false;
};
//# sourceMappingURL=isVisualBackgroundEnabled.js.map